/*
 * @Description:
 * @version:
 * @Date: 2024-01-09 16:45:35
 * @LastEditTime: 2024-02-05 14:35:11
 */
import { defineStore } from 'pinia';
import { loginApi } from '@/api/login.js';
import { MENU_TYPE_ENUM } from '@/constants/system';
import { localSave, localRead, localRemove } from '@/utils/local-util';
import localStorageKeyConst from '@/constants/local-storage-key-const';

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    userInfo: null
  }),
  getters: {
    getToken(state) {
      return state.userInfo ? state.userInfo.token : null;
    },
    getMenuPermissionList(state) {
      if (state.userInfo) {
        return state.userInfo.menuPermissionList || [];
      }
      return [];
    },
    getUserMenuList(state) {
      return state.getMenuPermissionList.filter((item) => item.menuType !== MENU_TYPE_ENUM.FUNCTION.value);
    },
    getUserPermissionList(state) {
      return state.getMenuPermissionList.filter((item) => item.menuType === MENU_TYPE_ENUM.FUNCTION.value);
    }
  },
  actions: {
    getStorageUserInfo() {
      const userInfo = localRead(localStorageKeyConst.USER_INFO) || null;
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
      }
    },

    saveUserInfo(userInfo) {
      this.userInfo = userInfo;
      localSave(localStorageKeyConst.USER_INFO, JSON.stringify(userInfo));
    },

    removeUserInfo() {
      this.userInfo = null;
      localRemove(localStorageKeyConst.USER_INFO);
      localRemove(localStorageKeyConst.NAV_TAGS);
      window.location.reload();
    },

    async logout() {
      try {
        await loginApi.logout();
      } catch (err) {
        console.log(err);
      } finally {
        this.removeUserInfo();
      }
    }
  }
});
